<div class="absolute inset-0 flex items-center justify-center text-gray-500 z-10">
  <span>{{ message() }}</span>
</div>
